export enum MenuLinkTypeEnum {
  link_type_custom_url = 'link_type_custom_urL',
  link_type_blog_page = 'link_type_blog_page',
  link_type_website_page = 'link_type_website_page',
}
